'use strict';


// Constructor
var Menu = function() {

	var isDragging = false;
	var isTouching = ("ontouchstart" in document.documentElement);

	//Navigation
	// if(!isTouching){
		$('.first-level-item.haschild').on('mouseenter', function(e){
			$(this).addClass('active');
			$('.overlay').addClass('active');
		});

		$('.first-level-item.haschild').on('mouseleave', function(e){
				$(this).removeClass('active');
				$('.overlay').removeClass('active');
		});
	// }

	$('body').on('touchstart', function(e){
		isDragging = false;
		isTouching = true;
		var x = $(e.target).is('.toolbarsearch, .toolbarsearch *');
		var y = $(e.target).is('.profile, .profile *');
		if(!x){
			$('.toolbarsearch .search').removeClass('active');
			$('.toolbarsearch').removeClass('active');
		}
		if(!y){
			$('.mycevn').removeClass('active');
		}
	});

	$('body').on('touchmove', function(e){
		isDragging = true;
	});

	$('body').on('touchend', function(e){
		isTouching = false;
		if($('.search').hasClass('.active')){
		}
		var x = $(e.target).is('.first-level li.haschild');
		var y = $(e.target).is('.first-level li.haschild.active');
		if(x && !isDragging){
			$('.first-level li.haschild').removeClass('active');
			$('.dismiss').addClass('active');
			$(e.target).addClass('active');
			$('.overlay').addClass('active');
			var left = $(e.target).offset().left
			var width = $('.first-level').width();
		var diff = left - width/3;
			$('.first-level').animate({
			scrollLeft: $('.first-level').scrollLeft()+diff
		}, 500);
		}
		if(y && !isDragging){
			$('.first-level li.haschild.active').addClass('touch');
		}
	});

	//Expand third level
	if ( $(window).width() <= 1024 ){
		$('.third-level').slideUp();
	}
	$('.second-level-item .expand-child').on('click', function(){
		$('.third-level').slideUp();
		//$('.second-level-item').removeClass('isExpanded');
		if( $(this).parent('.second-level-item').hasClass('isExpanded')){
			$('.second-level-item').removeClass('isExpanded');
			//$(this).parent('.second-level-item').removeClass('isExpanded');
			$(this).next('.third-level').slideUp();
		}
		else{
			$('.second-level-item').removeClass('isExpanded');
			$(this).parent('.second-level-item').addClass('isExpanded');
			$(this).next('.third-level').slideDown();
		}
		$('html, body').animate({
			scrollTop: $(this).offset().top
		}, 300);
	});

	$('.dismiss').on('click', function(e){
		$('.first-level-item.haschild').removeClass('active');
		$('.overlay').removeClass('active');
		$(this).removeClass('active');
		$('.third-level').slideUp();
		$('.second-level-item').removeClass('isExpanded');
//		$('html, body').animate({
//			scrollTop: $('#header').offset().top
//		}, 500);
	});
	$('.overlay').on('click', function(e){
		$('.first-level-item.haschild').removeClass('active');
		$('.dismiss').removeClass('active');
		$(this).removeClass('active');
		$('.third-level').slideUp();
		$('.second-level-item').removeClass('isExpanded');
	});

	$('.sitemapList >ul > li > a').wrap('<h2></h2>');

	//Interior article navigation hash
	var currentHash = '#';
	if ($('.page_article h2').length > 1){
		$('.page_article h2').each(function(index){
			var title = $(this).text();
			var id = title.replace(/\s+/g, '-').toLowerCase();
			var link = '#'+id;
			var navItem = '<li><a href="'+link+'">'+title+'</a><li>';
			$(this).attr('id', id);
			$('.sticky .page_nav ul').append(navItem);
			$('.sticky').show();
		});

		$(document).scroll(function () {
			$('main article').each(function () {
				var top = window.pageYOffset;
				var distance = top - $(this).offset().top;
				var hash = $('h2', this).attr('id');
				if (distance < 30 && distance > -30 && currentHash != hash) {
					window.location.hash = (hash);
					currentHash = hash;
					$('.sticky a').removeClass('active');
					$('a[href$="'+currentHash+'"]').toggleClass('active');
				}
			});
		});

		//Smooth scrolling for hash # links
		$('.sticky a[href*="#"]').not('[href="#"]').click(function(event) {
			event.preventDefault();
			var target = $(this.hash);
			$('html, body').animate({
			scrollTop: target.offset().top
			}, 500);
		});
	}
	else{
		$('.sticky .page_nav').css('display','none');
	}

};

module.exports = Menu;
